<template>
  <v-app class="userpg" v-bind:class="{ xsOnly: $vuetify.breakpoint.xsOnly }">
    <v-content :class='this.$vuetify.breakpoint'>
      <v-container fill-height >
        <v-layout align-center>
          <v-flex>
            <div class="h-hold text-xs-center">
              <a class="h-logohold" href="https://tryworktabs.com">
              <div class="h-logo"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255.21 255.12"><title>Logo</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="line" width="28.35" height="255.12"/><rect class="line" x="57.09" width="28.35" height="255.12"/><rect class="line" x="114.18" width="28.35" height="255.12"/><rect class="line" x="169.77" width="28.35" height="255.12"/><rect class="line" x="226.86" width="28.35" height="255.12"/></g></g></svg></div>
              <span class="logo-text">Worktabs</span>
            </a>
            <v-layout row v-if="error">
              <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-flex>
            </v-layout>
            <div class="entrycard mb-4">
              <h1 class="mt-0 mb-3 text-xs-center" v-if='group.subscription.status === "suspended"'>Reactivate</h1>
            <h1 class="mt-0 mb-3 text-xs-center" v-else-if='group.subscription.status === "trialExpired"'>Trial Expired</h1>
            <h1 class="mt-0 mb-3 text-xs-center" v-else>Reactivated!</h1>
              <p v-if='group.subscription.status === "suspended"'>Your account has been suspended due to non payment.<br>Please choose a plan to reactivate your account.</p>
              <p v-if='group.subscription.status === "trialExpired"'>Please choose a plan to reactivate your account.</p>
              <div v-if='group.subscription.status === "trialExpired" || group.subscription.status === "suspended"'>
                <div v-if='pricingtableid'>
                  <stripe-pricing-table
                  :pricing-table-id='pricingtableid'
                  :publishable-key='publishablekey'
                  :client-reference-id='userGroup'
                  :customer-email='email'
                  >
                </stripe-pricing-table>
              </div>
                <p class="caption">Prices excluding VAT at 20%</p>
              </div>
              <p v-else>Your account is now active. <a href="/sign-in">Click here to login</a></p>
              </div>
              <p class="account-link pt-2 text-dark--text body bold text-xs-center"><router-link :to="{name: 'ForgotPassword'}" class="pr-2 mutedprimary--text">Forgot password?</router-link></p>
              <p class="account-link pt-2 text-dark--text body bold text-xs-center"><a class="pr-2 mutedprimary--text" @click.stop="onLogout()">Logout</a></p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

export default {
  // using the computeds for the stripe card as it seems to load in prior to the data bracket is loaded
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    group () {
      return this.$store.getters.group
    },
    pricingtableid () {
      return process.env.VUE_APP_STRIPEPRICINGTABLEID
    },
    publishablekey () {
      return process.env.VUE_APP_STRIPEPUBKEY
    },
    email () {
      return this.$store.getters.user.email
    },
    userGroup () {
      return this.$store.getters.user.group
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('logout')
      this.$router.push('/sign-in')
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>

<style lang="scss" scoped>
a.h-logohold{
  margin-bottom:40px;
    display:flex;
    justify-content: center;
    align-items: center;
  .logo-text{
    margin-left:10px;
    color:var(--mutedprimary);
    font-weight:700;
    font-size:2rem;
  }
    .h-logo{
      margin-top:-2px;
      width:15px;
      height:15px;
      rect{
        fill:var(--green);
      }
    }
}
.h-hold{
  max-width:800px;
  margin:0 auto;

  h1{
    font-family:"suisse_intl", Arial !important;
    font-size:1.6rem ;
    letter-spacing:0 !important;
    font-weight:700;
    text-align:left;
    margin-bottom:30px;
    .xsOnly &{
      font-size:2.4rem;
    }
  }
  a {
    text-decoration: none;
    color:var(--green);
  }
}
</style>
